/* Fade image in when loaded */
import React from 'react'
import PropTypes from 'prop-types'
import styles from './Img.icss'
import getImageSrcByResolution from '../utilities/getImageSrcByResolution'

class Img extends React.Component {
	static getDerivedStateFromProps(props, state) {
		const imgSrc = getImageSrcByResolution(props)

		return { imgSrc, loaded: state.imgSrc !== imgSrc ? false : state.loaded }
	}

	constructor(props) {
		super(props)

		this.imageLoader = new global.Image()
		this.imageLoader.onload = () => {
			this.setState({ loaded: true })
		}

		this.state = { imgSrc: undefined, loaded: false }

		this.waitForImageLoad = this.waitForImageLoad.bind(this)
	}

	componentDidMount() {
		this.waitForImageLoad()
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.imgSrc !== this.state.imgSrc) {
			this.waitForImageLoad()
		}
	}

	componentWillUnmount() {
		this.imageLoader.onload = undefined
	}

	waitForImageLoad() {
		this.imageLoader.src = this.state.imgSrc
	}

	render() {
		//	Remove props we don't want to add directly to the native image tag
		const { className, content, divisor, resolution, sizeType, fadein, ...props } = this.props
		let rootClassName = styles.image + (className ? ` ${className}` : '')
		if (this.state.loaded) {
			rootClassName += ` ${fadein ? styles.imageLoadedFadein : styles.imageLoaded}`
		}
		return <img alt="" {...props} className={rootClassName} src={this.state.imgSrc} />
	}
}

Img.propTypes = {
	content: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }),
		PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }))
	]),
	divisor: PropTypes.number,
	fadein: PropTypes.bool,
	className: PropTypes.string,
	resolution: PropTypes.string,
	sizeType: PropTypes.string
}

Img.defaultProps = {
	content: undefined,
	divisor: 1,
	fadein: true,
	className: undefined,
	resolution: undefined,
	sizeType: undefined
}

export default Img



// WEBPACK FOOTER //
// ./src/components/Img.jsx